import { string } from "yup";

export const EMAIL_REGEX =
  /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

export const EMAIL_INVALID_MESSAGE =
  "Email invalide. Les caractères spéciaux sont interdits.";

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_RULES_MESSAGE =
  "Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.";

export const PASSWORD_RULES_HINT =
  "8 caractères minimum, dont une majuscule, une minuscule, un chiffre et un caractère spécial.";

export function passwordSchema() {
  return string()
    .min(PASSWORD_MIN_LENGTH, PASSWORD_RULES_MESSAGE)
    .max(250, "250 caractères maximum")
    .matches(/[A-Z]/, PASSWORD_RULES_MESSAGE)
    .matches(/[a-z]/, PASSWORD_RULES_MESSAGE)
    .matches(/[0-9]/, PASSWORD_RULES_MESSAGE)
    .matches(/[^A-Za-z0-9]/, PASSWORD_RULES_MESSAGE);
}
